import Toolbar, { Item } from "devextreme-react/toolbar";
import { Form, SimpleItem, GroupItem } from "devextreme-react/form";
import { DataGrid, Button, Selection, Editing, Column, Toolbar as GridToolbar, Item as GridItem } from "devextreme-react/data-grid";
import { useState, useEffect, useCallback, useRef } from "react";
import { PostData } from "../../../Helper";

import { List } from "devextreme-react";
import { Popup } from "devextreme-react/popup";
import { Button as XButton } from "devextreme-react/button";
import TestQustionForm from "./test_question_form";
export default function Test() {
  const [mode, setMode] = useState(0);
  const [questionMode, setQuestionMode] = useState(0);
  const [sections, setSections] = useState([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [types, setTypes] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const listRef = useRef(null);
  const gridQuestion = useRef(null);
  const [tests, setTests] = useState([]);
  const [currentSections, setCurrentSections] = useState([]);
  const [pairFiles, setPairFiles] = useState([]);
  const [pairWords, setPairWords] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [deletedId, setDeletedId] = useState();
  const [showQuestionForm, setShowQuestionForm] = useState(false);
  const [questionFormData, setQuestionFormData] = useState({});
  const [typesCount, setTypesCount] = useState({});
  const [formData, setFormData] = useState({
    id: 0,
    name: "",
    date: new Date(),
    time_start: "",
    subject_id: "",
    weight_1: 0,
    weight_2: 0,
    weight_3: 0,
    weight_4: 0,
    weight_5: 0,
  });

  useEffect(() => {
    const counts = { type_1: 0, type_2: 0, type_3: 0, type_4: 0, type_5: 0 };
    for (let index = 0; index < questions.length; index++) {
      const type = questions[index].question_type_id;
      if (type == 1) counts.type_1 += 1;
      if (type == 2) counts.type_2 += 1;
      if (type == 3) counts.type_3 += 1;
      if (type == 4) counts.type_4 += 1;
      if (type == 5) counts.type_5 += 1;
    }
    setTypesCount((prev) => ({ ...prev, ...counts }));
  }, [questions]);

  useEffect(() => {
    PostData({
      url: "test/question_type",
      showLoading: false,
      success: (e) => {
        setTypes(e);
      },
    });
    PostData({
      url: "study_section",
      showLoading: false,

      success: (e) => setSections(e),
    });
    PostData({
      url: "subjects",
      showLoading: false,

      success: (e) => setSubjects(e),
    });

    PostData({
      url: "test",
      showLoading: false,
      success: (e) => setTests(e),
    });
  }, []);

  function refreshTest() {
    PostData({
      url: "test",
      showLoading: false,
      success: (e) => setTests(e),
    });
  }

  const clearForm = useCallback(
    (e) => {
      setTypesCount({});
      setShowDrawer(false);
      setFormData({});
      setPairWords([]);
      setPairFiles([]);
      setQuestionFormData({});
      listRef.current.instance.option("selectedItems", []);
      setQuestions([]);
    },
    [setQuestionFormData, setFormData, setPairFiles, setPairWords, setShowDrawer, setQuestions]
  );

  function validateData(currentSections, questions, formData) {
    const totalWeight = formData.weight_1 + formData.weight_2 + formData.weight_3 + formData.weight_4 + formData.weight_5;

    if (totalWeight < 100 || totalWeight > 100) {
      window.toastr.warning("Jumlah Bobot harus 100!");
      return false;
    }
    if (currentSections.length <= 0) {
      window.toastr.warning("Jam ke wajib pilih!");
      return false;
    }

    if (questions.length <= 0) {
      window.toastr.warning("Soal ke wajib disikan!");
      return false;
    }
    return true;
  }

  const submitForm = useCallback(() => {
    if (!validateData(currentSections, questions, formData)) return;
    if (mode == 1) insertData();
    if (mode == 2) updateData();
    if (mode == 3) deleteData();
  }, [currentSections, questions, formData]);

  const insertData = useCallback(() => {
    let newFormData = { ...formData };
    newFormData.time_start = newFormData.time_start.toLocaleTimeString("en-US", { hour12: false });
    newFormData.date = newFormData.date.toISOString().slice(0, 10);

    const body = {
      sections: currentSections.map((section) => ({
        study_section_id: section.id,
      })),
      data: newFormData,
      questions: questions,
      words: pairWords,
    };

    PostData({
      url: "test/create",
      showLoading: false,
      data: body,

      success: (e) => {
        if (pairFiles.length > 0) {
          var data = new FormData();
          data.append("id", e.id);
          data.append("mode", mode);
          for (let i = 0; i < pairFiles.length; i++) {
            const left = pairFiles[i].left;
            const right = pairFiles[i].right;
            const tag = pairFiles[i].no;

            data.append("left[]", left, left.name);
            data.append("right[]", right, right.name);
            data.append("tags[]", tag);
          }
          PostData({
            url: "test/create/files",
            showLoading: false,
            data: data,
            headers: { "Content-Type": "multipart/form-data" },
            success: (e) => {
              window.toastr.success("Berhasil disimpan");
              clearForm();
              setMode(0);
              refreshTest();
            },
          });
        } else {
          window.toastr.success("Berhasil disimpan");
          clearForm();
          setMode(0);
          refreshTest();
        }
      },
    });
  }, [currentSections, questions, formData, pairWords, pairFiles]);

  const loadData = (e) => {
    setShowDrawer(false);
    setMode(2);
    PostData({
      url: "test/" + e.row.data.id,
      showLoading: false,
      success: (e) => {
        setCurrentSections((_) => e.sections);
        setQuestions((_) => e.questions);
        setFormData((_) => e.test);
      },
    });
  };
  const updateData = useCallback(() => {
    const body = {
      sections: currentSections.map((section) => ({
        study_section_id: section.id,
      })),
      data: formData,
      questions: questions,
      words: pairWords,
    };
    PostData({
      url: "test/update",
      showLoading: false,
      data: body,

      success: (e) => {
        console.log(pairFiles);
        if (pairFiles.length > 0) {
          var data = new FormData();
          data.append("id", e.id);
          data.append("mode", mode);
          for (let i = 0; i < pairFiles.length; i++) {
            const left = pairFiles[i].left;
            const right = pairFiles[i].right;
            const tag = pairFiles[i].no;
            data.append("left[]", left, left.name);
            data.append("right[]", right, right.name);
            data.append("tags[]", tag);
          }
          PostData({
            url: "test/update/files",
            showLoading: false,
            data: data,
            headers: { "Content-Type": "multipart/form-data" },
            success: (e) => {
              window.toastr.success("Berhasil disimpan");
              clearForm();
              setMode(0);
              refreshTest();
            },
          });
        } else {
          window.toastr.success("Berhasil disimpan");
          clearForm();
          setMode(0);
          refreshTest();
        }
      },
    });
  }, [currentSections, questions, formData, pairFiles, pairWords]);

  const confirmDelete = useCallback((e) => {
    setShowDialog(true);
    setDeletedId(e.row.data.id);
  }, []);
  const deleteData = useCallback(() => {
    setShowDrawer(false);
    setShowDialog(false);

    PostData({
      url: "test/delete",
      showLoading: false,
      data: { id: deletedId },
      success: (e) => {
        window.toastr.success("Berhasil dihapus");

        setMode(0);
        refreshTest();
      },
    });
  }, [deletedId]);

  const editQuestion = useCallback(
    (e) => {
      setQuestionFormData(e.row.data);

      setQuestionMode(2);
      setShowQuestionForm(true);
    },
    [setShowQuestionForm, questionFormData, setQuestionFormData, setQuestionMode]
  );

  const form = useRef();
  return (
    <div className="h-100 w-100 overflow-auto">
      <Popup
        visible={showQuestionForm}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showSelectionControls={true}
        title="Form Pertanyaan"
        onHiding={(e) => {
          setQuestionFormData({});
          setShowQuestionForm(false);
        }}
      >
        <TestQustionForm
          setPairWords={setPairWords}
          setPairFiles={setPairFiles}
          types={types}
          setTypes={setTypes}
          questions={questions}
          setEditFormData={setQuestionFormData}
          editFormData={questionFormData}
          setShowQuestionForm={setShowQuestionForm}
          setQuestions={setQuestions}
          mode={questionMode}
        />
      </Popup>
      <Popup
        onHiding={() => setShowDialog(false)}
        dragEnabled={false}
        visible={showDialog}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showSelectionControls={true}
        showTitle={true}
        title="Apakah anda yakin?"
        width={300}
        height={180}
        position="center"
      >
        <p className="text-center">Hapus Data</p>
        <div className="row mt-2">
          <XButton text="Tidak" stylingMode="text" className="col-md-4" onClick={() => setShowDialog(false)} />
          <div className="col-md-4"></div>
          <XButton text="Iya" stylingMode="text" className="col-md-4" onClick={deleteData} />
        </div>
      </Popup>
      <div className="border-bottom mb-1">
        <Toolbar c>
          <Item
            widget="dxButton"
            options={{
              icon: "plus",
              type: "default",
              stylingMode: "outlined",
              text: "Baru",
              onClick: () => {
                clearForm();
                setMode(1);
              },
              disabled: mode !== 0,
            }}
            location="before"
          />
          <Item
            widget="dxButton"
            options={{
              icon: "edit",
              type: "success",
              stylingMode: "contained",
              text: "Ubah",
              onClick: () => {
                setShowDrawer(true);
                setMode(-1);
              },
              disabled: mode !== 0,
            }}
            location="before"
          />
          <Item
            widget="dxButton"
            options={{
              icon: "save",
              type: "default",
              stylingMode: "contained",
              text: "Simpan",
              onClick: () => submitForm(),
              disabled: mode == 0 || mode == -1,
            }}
            location="before"
          />
          <Item
            widget="dxButton"
            options={{
              icon: "close",
              type: "danger",
              stylingMode: "contained",
              text: "Batal",
              onClick: () => {
                clearForm();
                setMode(0);
              },
              disabled: mode === 0,
            }}
            location="before"
          />
        </Toolbar>
      </div>

      <div className="row w-full h-100">
        {showDrawer && (
          <div className="col-md-4">
            <DataGrid disabled={!showDrawer} dataSource={tests}>
              <Selection mode="single" />

              <Column dataField="name" caption="Nama" />
              <Column
                dataField="date"
                caption="Tanggal"
                editorType="dxDateBox"
                editorOptions={{ displayExpr: "name", valueExpr: "id", dataSource: subjects }}
              />
              <Column
                dataField="time_start"
                caption="Jam Mulai"
                visible={false}
                editorType="dxDateBox"
                editorOptions={{ type: "datetime", displayFormat: "shortTime", defaultValue: new Date(), calendarOptions: { visible: false } }}
              />
              <Column type="buttons">
                <Button hint="Ubah" icon="edit" visible={true} onClick={loadData} />
                <Button hint="Hapus" icon="close" visible={true} onClick={confirmDelete} />
              </Column>
            </DataGrid>
          </div>
        )}

        <div className={showDrawer ? "col-md-8 w-full" : "w-full col-md-12"}>
          <div className="row mx-2 my-2">
            <form className="col-md-6 " ref={form} onSubmit={submitForm}>
              <Form formData={formData} className="row" disabled={mode === 0} labelLocation="top" colCount={2}>
                <SimpleItem dataField="name" isRequired={true} label={{ text: "Nama" }} />
                <SimpleItem
                  isRequired={true}
                  label={{ text: "Tanggal" }}
                  dataField="date"
                  editorType="dxDateBox"
                  editorOptions={{ type: "date", displayFormat: "EEEE, dd MMM yyyy", defaultValue: new Date() }}
                />
                <SimpleItem
                  isRequired={true}
                  label={{ text: "Jam Mulai" }}
                  dataField="time_start"
                  editorType="dxDateBox"
                  editorOptions={{ type: "datetime", displayFormat: "shortTime", defaultValue: new Date(), calendarOptions: { visible: false } }}
                />
                <SimpleItem
                  isRequired={true}
                  label={{ text: "Mata Pelajaran" }}
                  dataField="subject_id"
                  editorType="dxSelectBox"
                  editorOptions={{ displayExpr: "name", valueExpr: "id", dataSource: subjects }}
                />
                <GroupItem colCount={2} caption="Pembobotan" colSpan={2}>
                  <SimpleItem
                    isRequired={true}
                    label={{ text: `Bobot Pilihan Ganda (${typesCount.type_1})` }}
                    dataField="weight_1"
                    editorType="dxNumberBox"
                    disabled={typesCount.type_1 <= 0}
                  />
                  <SimpleItem
                    isRequired={true}
                    label={{ text: `Bobot Benar Salah (${typesCount.type_2})` }}
                    dataField="weight_2"
                    editorType="dxNumberBox"
                    disabled={typesCount.type_2 <= 0}
                  />
                  <SimpleItem
                    isRequired={true}
                    label={{ text: `Bobot Menjodohkan (${typesCount.type_3})` }}
                    dataField="weight_3"
                    editorType="dxNumberBox"
                    disabled={typesCount.type_3 <= 0}
                  />
                  <SimpleItem
                    isRequired={true}
                    label={{ text: `Bobot Isian (${typesCount.type_4})` }}
                    dataField="weight_4"
                    editorType="dxNumberBox"
                    disabled={typesCount.type_4 <= 0}
                  />
                  <SimpleItem
                    isRequired={true}
                    label={{ text: `Bobot Essay (${typesCount.type_5})` }}
                    dataField="weight_5"
                    editorType="dxNumberBox"
                    disabled={typesCount.type_5 <= 0}
                  />
                </GroupItem>
              </Form>
            </form>
            <div className="col-md-6  p-2">
              <span className="dx-field-item-label-text">Jam Ke</span>
              <div className="flex border">
                <List
                  onSelectedItemsChange={(e) => {
                    setCurrentSections((_) => e);
                  }}
                  selectedItems={currentSections}
                  ref={listRef}
                  disabled={mode == 0}
                  dataSource={sections}
                  displayExpr="name"
                  selectionMode="multiple"
                  showSelectionControls={true}
                  valueExpr="id"
                  keyExpr="id"
                  height={200}
                  showScrollbar="always"
                />
              </div>
            </div>
          </div>

          <div className="mx-2">
            <span className=" dx-field-item-label-text">Soal</span>
            <DataGrid disabled={mode == 0} dataSource={questions} ref={gridQuestion} keyExpr="id">
              <Editing mode="form" useIcons={true} allowAdding={false} allowUpdating={false} allowDeleting={true} />
              <Selection mode="single" />
              <GridToolbar>
                <GridItem
                  widget="dxButton"
                  options={{
                    icon: "plus",
                    type: "default",
                    stylingMode: "outlined",
                    text: "Tambah Soal",
                    onClick: (e) => {
                      setQuestionMode(1);
                      setShowQuestionForm(true);
                    },
                  }}
                  location="before"
                />
              </GridToolbar>

              <Column type="buttons">
                <Button hint="Ubah" icon="edit" visible={true} onClick={editQuestion} />
              </Column>

              <Column
                dataField="no"
                width={60}
                caption="No"
                dataType="number"
                editorType="dxNumberBox"
                editorOptions={{ showSpinButtons: true, min: 1 }}
              />
              <Column dataField="question" caption="Pertanyaan" editorType="dxTextArea" />
              <Column
                dataField="question_type_id"
                caption="Jenis Pertanyaan"
                editorType="dxSelectBox"
                editorOptions={{
                  displayExpr: "name",
                  valueExpr: "id",
                  dataSource: types,
                }}
                colSpan={3}
              />
            </DataGrid>
          </div>
        </div>
      </div>
    </div>
  );
}
